import { TranslationService, UtilService } from 'src/app/shared';
import { DialogResult } from './../../../shared/dialog/dialog-result.model';
import { ConfirmSafeguardDialogComponent } from './../../../shared/widgets/confirm-safeguard-dialog/confirm-safeguard-dialog.component';
import { InvoiceLineItemUpsertDto } from './../../dto/invoice-line-item-upsert.dto';
import { InvoicePaymentUpsertDto } from './../../dto/invoice-payment-upsert.dto';
import { Component, OnInit, Input, Output, OnChanges, EventEmitter, ViewChild, SimpleChanges } from '@angular/core';
import { PaymentTypeDto } from 'src/app/revenue/shared/payment-types/dto/payment-type.dto';
import { PaymentSource } from 'src/app/revenue/shared/payment-source/payment-source.model';
import { ConfirmationService } from 'primeng/api';
import { TransactionService } from 'src/app/revenue/shared/transaction/transaction.service';
import { TransactionSearchDto } from 'src/app/revenue/shared/transaction/dto/transaction-search.dto';
import { RevenueObservationService } from 'src/app/revenue/shared/revenue-observation.service';

@Component({
  selector: 'wl-invoice-payment-edit',
  templateUrl: './invoice-payment-edit.component.html',
  styleUrls: ['./invoice-payment-edit.component.less'],
  providers: [ConfirmationService],
    standalone: false
})
export class InvoicePaymentEditComponent implements OnInit, OnChanges {
  @Input() payment: InvoicePaymentUpsertDto;
  @Input() paymentTypes: Array<PaymentTypeDto>;
  @Input() lineItem: InvoiceLineItemUpsertDto;
  @Input() paymentSources: Array<PaymentSource>;
  @Input() flatPaymentIds: Array<number>;
  @Output() removeClicked: EventEmitter<any> = new EventEmitter();

  @ViewChild(ConfirmSafeguardDialogComponent) confirmation;

  public selectedPaymentType: PaymentTypeDto;
  public selectedPaymentSource: PaymentSource;
  public isAltRow = false;
  public creditAccount: string;
  public debitAccount: string;
  private _cleanPayment: string;

  constructor(
    public revenueObservationService: RevenueObservationService,
    private _confirmationService: ConfirmationService,
    private _translationService: TranslationService,
    private _transactionService: TransactionService,
    private _utilService: UtilService
  ) {}

  ngOnInit() {
    this.revenueObservationService.observeRequestInvoiceUpsert().subscribe(() => {
      this.setDirty();
    });
    this.revenueObservationService.observeInvoiceLoaded().subscribe(() => {
      this.setCleanObject();
    });
    this.setCleanObject();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.payment && this.paymentTypes) {
      this.selectedPaymentType = this.paymentTypes.find((x) => x.PaymentTypeId === this.payment.PaymentTypeID);
    }

    if (this.payment && this.paymentSources) {
      this.selectedPaymentSource = this.paymentSources.find((x) => x.PaymentSource === this.payment.PaymentSource);
    }

    if (this.payment && this.flatPaymentIds) {
      this.isAltRow = this.flatPaymentIds.findIndex((x) => x === this.payment.PaymentID) % 2 !== 0;
    }

    this.setAccounts();
  }

  get dirty() {
    const stripped = this.getStrippedAndCleanedObject();
    return JSON.stringify(stripped) != this._cleanPayment;
  }

  private setDirty() {
    this.payment.Dirty = this.dirty;
  }

  private setCleanObject() {
    const stripped = this.getStrippedAndCleanedObject();
    this._cleanPayment = JSON.stringify(stripped);
  }

  private getStrippedAndCleanedObject() {
    const stripped = this._utilService.clone(this.payment);
    stripped.AdjustmentAmountToApply = stripped.AdjustmentAmountToApply ?? 0;
    return stripped;
  }


  public paymentTypeChanged(event) {
    this.payment.PaymentType = this.selectedPaymentType.PaymentType;
    this.payment.PaymentTypeID = this.selectedPaymentType.PaymentTypeId;
  }

  public paymentSourceChanged(event) {
    this.payment.PaymentSource = this.selectedPaymentSource.PaymentSource;
  }

  public removeSafe() {
    if (this.payment.Adjustments && this.payment.Adjustments.length > 0) {
      this._translationService.get('invoices.invoice-builder.payment-tab.adjustment-warning-message').then((data: string) => {
        this._confirmationService.confirm({
          message: data,
          accept: () => {
            this.removeClicked.emit();
          },
          reject: () => {
            this._confirmationService.close();
          },
        });
      });
    } else {
      this.removeClicked.emit();
    }
  }

  private setAccounts() {
    if (this.payment?.Posted) {
      this._transactionService.search(new TransactionSearchDto({ PaymentId: this.payment.PaymentID, PageSize: 0 })).then((result) => {
        const creditTransaction = result.Result?.find((x) => x.CreditAmount > 0);
        const debitTransaction = result.Result?.find((x) => x.DebitAmount > 0);
        this.creditAccount = creditTransaction?.Account;
        this.debitAccount = debitTransaction?.Account;
      });
    } else {
      this.creditAccount = this.selectedPaymentType?.CreditAccount;
      this.debitAccount = this.selectedPaymentType?.DebitAccount;
    }
  }
}
